<his-plam [hidden]="isHidden">
	<p-autoComplete #content hisDdKey="de.his.translate"
		[suggestions]="filteredTranslationLanguages"
        [(ngModel)]="currentLanguage"
		(completeMethod)="filterTranslationLanguages($event)"
		(onSelect)="onTranslationLanguageSelect($event)"
		field = "text" [minLength]="1" [dropdown]="true">
	</p-autoComplete>
</his-plam>
